import { getData, postData } from "../api/api";

export type ChatTurnJobStatus = "RUNNING" | "BACKGROUND" | "SUCCEEDED" | "FAILED" | "CANCELLED";

export interface ChatTurnTimelineEntry {
  step?: string;
  tool?: string;
  detail?: string;
  at?: string;
}

export interface ChatTurnJobView {
  turnId: string;
  status: ChatTurnJobStatus;
  background?: boolean;
  step?: string;
  tool?: string;
  timeline?: ChatTurnTimelineEntry[];
  question?: string;
  cancelRequested?: boolean;
  correlationId?: string;
  messageId?: string;
  startedAt?: string;
  backgroundAt?: string;
  finishedAt?: string;
  error?: string;
}

export function isTerminalChatTurnStatus(status: ChatTurnJobStatus | undefined): boolean {
  return status === "SUCCEEDED" || status === "FAILED" || status === "CANCELLED";
}

const BASE = "/api/chat/turns";

export const chatTurnJobService = {
  listOpen: (correlationId: string) =>
    getData(`${BASE}?correlationId=${encodeURIComponent(correlationId)}`) as Promise<ChatTurnJobView[]>,

  get: (turnId: string) => getData(`${BASE}/${turnId}`) as Promise<ChatTurnJobView>,

  cancel: (turnId: string) => postData(`${BASE}/${turnId}/cancel`, {}) as Promise<ChatTurnJobView>,
};

export function parseChatTurnJob(raw: unknown): ChatTurnJobView | undefined {
  if (!raw || typeof raw !== "object") return undefined;
  const o = raw as Record<string, unknown>;
  const turnId = typeof o.turnId === "string" ? o.turnId : undefined;
  const status = typeof o.status === "string" ? (o.status as ChatTurnJobStatus) : undefined;
  if (!turnId || !status) return undefined;
  return {
    turnId,
    status,
    background: Boolean(o.background),
    step: typeof o.step === "string" ? o.step : undefined,
    tool: typeof o.tool === "string" ? o.tool : undefined,
    timeline: Array.isArray(o.timeline) ? (o.timeline as ChatTurnTimelineEntry[]) : [],
    question: typeof o.question === "string" ? o.question : undefined,
    cancelRequested: Boolean(o.cancelRequested),
    correlationId: typeof o.correlationId === "string" ? o.correlationId : undefined,
    messageId: typeof o.messageId === "string" ? o.messageId : undefined,
    startedAt: typeof o.startedAt === "string" ? o.startedAt : undefined,
    backgroundAt: typeof o.backgroundAt === "string" ? o.backgroundAt : undefined,
    finishedAt: typeof o.finishedAt === "string" ? o.finishedAt : undefined,
    error: typeof o.error === "string" ? o.error : undefined,
  };
}
